import type { ComponentProps, ReactNode } from "react";

import { cn } from "@/lib/cn";

export interface CardProps extends ComponentProps<"div"> {
  /** `dark` para tarjetas sobre el fondo Carbón del POS. */
  tone?: "light" | "dark";
}

export function Card({ tone = "light", className, children, ...rest }: CardProps) {
  return (
    <div
      className={cn(
        "rounded-msr-lg border",
        tone === "light"
          ? "border-line bg-snow text-carbon"
          : "border-white/10 bg-ink-soft text-white",
        className,
      )}
      {...rest}
    >
      {children}
    </div>
  );
}

export interface CardHeaderProps extends ComponentProps<"div"> {
  title: string;
  description?: string;
  actions?: ReactNode;
}

export function CardHeader({ title, description, actions, className, ...rest }: CardHeaderProps) {
  return (
    <div
      className={cn("flex items-start justify-between gap-4 border-b border-line/70 p-4", className)}
      {...rest}
    >
      <div className="min-w-0">
        <h2 className="font-display text-base font-bold">{title}</h2>
        {description ? <p className="text-muted mt-0.5 text-sm">{description}</p> : null}
      </div>
      {actions}
    </div>
  );
}
